export default function validate(fields) {
    const errors = {}
    const { clientId, agentId, intervalSeconds } = fields
    if (typeof clientId === 'undefined' || clientId === '') {
        errors.clientId = 'Client Id must not be empty'
    }

    if (typeof agentId === 'undefined' || agentId === '') {
        errors.agentId = 'Agent Id must not be empty'
    }

    if (/\s/.test(agentId)) {
        errors.agentId = 'Agent Id must not contain spaces'
    }
    if (/[A-Z]/.test(agentId)) {
        errors.agentId = 'Agent Id must not contain capital letters'
    }

    if (typeof intervalSeconds === 'undefined' || intervalSeconds === '') {
        errors.intervalSeconds = 'Interval Seconds must not be empty'
    }
    return errors
}



// WEBPACK FOOTER //
// ./src/smart-components/agent-form/validate.js